import { render, staticRenderFns } from "./ProductLegend.vue?vue&type=template&id=4b10c21e&"
import script from "./ProductLegend.vue?vue&type=script&lang=js&"
export * from "./ProductLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports